import { parseNumericHumanDate } from '~/DateTime';

export default class FilterParameter<Value extends string | string[], Name extends string = string> {
	name: Name;

	value: Value;

	constructor(name: Name, value: Value) {
		this.name = name;
		this.value = value;
	}

	updated(name: string, value: Value): FilterParameter<Value> {
		return new FilterParameter(name, value);
	}

	valueUpdated(value: Value): FilterParameter<Value> {
		return new FilterParameter(this.name, value);
	}

	equals(
		parameter: FilterParameter<string | string[]> | { name: string | string[]; value: string | string[] }
	): boolean {
		if (!(parameter instanceof FilterParameter) || this.name !== parameter.name) {
			return false;
		}
		if (typeof parameter.value === 'string') {
			return this.value === parameter.value;
		}
		if (this.value.length !== parameter.value.length) {
			return false;
		}

		const value = new Set(this.value);
		return parameter.value.find((item) => !value.has(item)) === undefined;
	}

	parseDateValue(): Date | null {
		if (typeof this.value === 'string') {
			return parseNumericHumanDate(this.value);
		}

		return null;
	}
}
